import { cardFactory } from '@liveauctioneers/hammer-ui-core/card/factory';

import { ItemSummary } from '@/types/item/ItemSummary';

import { DateAndHouseComponent } from './components/DateAndHouseComponent';
import { EstimateComponentSearchCard } from './components/EstimateComponentSearchCard';
import { ImageComponent } from './components/ImageComponent';
import { PriceComponentSearchCard } from './components/PriceComponentSearchCard';
import { SellerNameComponentSearchCard } from './components/SellerNameComponentSearchCard';
import { TitleComponentSearchCard } from './components/TitleComponentSearchCard';

export type SearchPageItemCardProps = ItemSummary & {
    hasNewSimilarItemsIconCTA?: boolean;
    position: number;
};

export const SearchPageItemCard = cardFactory<SearchPageItemCardProps>({
    components: [
        ImageComponent,
        DateAndHouseComponent,
        TitleComponentSearchCard,
        EstimateComponentSearchCard,
        PriceComponentSearchCard,
        SellerNameComponentSearchCard,
    ],
    name: 'SearchPageItemCard',
});
